// extracted by mini-css-extract-plugin
module.exports = {"cta":"CTA_cta__4T9_c","cta__text":"CTA_cta__text__aM7mw","btn":"CTA_btn__wSpV1"};